import { Typography, Stack } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import CheckoutLayoutItem from '../CheckoutLayoutItem';
import OrderTimeCard from '../OrderTime/OrderTime';

function OrderLabel({ trackOrder }) {
  const { orderType, trackOrderData } = useSelector(({ order, profile }) => ({
    orderType: order?.type,
    trackOrderData: profile.trackingOrderResponse?.response,
  }));

  const isDelivery = !trackOrder
    ? orderType?.label === 'Delivery'
    : trackOrderData?.type === 'delivery';

  const labelSubtitle = isDelivery
    ? 'To change to  delivery time, please go back.'
    : 'To change to  pickup time, please go back.';

  return (
    <CheckoutLayoutItem
      title="Order Details"
      subtitle={labelSubtitle}
      trackOrders={trackOrder}
    >
      <Stack
        spacing={1}
        justifyContent={{ xs: 'center', md: 'none' }}
        alignItems={{ xs: 'center', md: 'unset' }}
      >
        {isDelivery ? (
          <DirectionsCarIcon color="secondary" />
        ) : (
          <DirectionsWalkIcon color="secondary" />
        )}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          textTransform="capitalize"
        >
          {!trackOrder ? orderType?.label : trackOrderData?.type}
        </Typography>
        {!trackOrder && <OrderTimeCard color="text.secondary" />}
      </Stack>
    </CheckoutLayoutItem>
  );
}
export default OrderLabel;

OrderLabel.propTypes = {
  trackOrder: PropTypes.bool,
};

OrderLabel.defaultProps = {
  trackOrder: false,
};
